const Images={
slider1: require("./assets/img/monuments/Agrasen-Ki-Baoli-1-2-768x492.jpg"),
slider2: require("./assets/img/monuments/Chattarpur_Temple.jpg"),
slider3: require("./assets/img/monuments/Hauz-Khas.jpg"),
slider4: require("./assets/img/monuments/Jantar-Mantar_1400-1000x565.jpeg"),
slider5: require("./assets/img/monuments/Purana-Qila-Delhi.jpg"),
slider6: require("./assets/img/monuments/mugal_garden.jpg"),
slider7: require("./assets/img/monuments/bangla.jpg"),
slider8: require("./assets/img/monuments/lodi.jpg"),
slider9: require("./assets/img/monuments/jama-masjid-delhi.jpg"),
slider10: require("./assets/img/monuments/hanuman.jpg"),



slider11: require("./assets/img/monuments/Amer-Fort.jpg"),
slider12: require("./assets/img/monuments/city-palace-jaipur-tourmyindia.jpg"),
slider13: require("./assets/img/monuments/Chittorgarh2.jpg"),
slider14: require("./assets/img/monuments/Ranthambore-Fort-A-Marvel-Of-The-Chauhan-Dynasty.jpg"),
slider15: require("./assets/img/monuments/Hawa-Mahal-scaled.jpg"),
slider16: require("./assets/img/monuments/Mehrangarh.jpg"),
slider17: require("./assets/img/monuments/Jaisalmer.jpg"),
slider18: require("./assets/img/monuments/Kumbhalgarh-Fort-Entry-Fees-History-Architecture-Timings.jpg"),
slider19: require("./assets/img/monuments/Junagarh-Fort-Bikaner-Major-Attractions-and-Other-Details.jpg"),
slider120: require("./assets/img/monuments/Dilwara-Jain-Temple-Mount-Abu-Timings-Location-scaled.jpg"),


hotel1 : require( "./assets/img/hotels/hotel1.jpg"),
hotel2 : require( "./assets/img/hotels/hotel2.jpg"),
red_fort: require( "./assets/img/monuments/red_fort.jpg"),
qutub_minar : require( "./assets/img/monuments/qutub_minar.jpg"),
india_gate : require( "./assets/img/monuments/india_gate.jpg"),
lotus_temple : require( "./assets/img/monuments/lotus_temple.jpg"),
akshar : require( "./assets/img/monuments/akshar.jpg"),
bangla : require( "./assets/img/monuments/bangla.jpg"),
police : require( "./assets/img/emergency/police.jpg"),
cyber : require( "./assets/img/emergency/cyber.jpg"),
fire : require( "./assets/img/emergency/fire.jpg"),
ambulance : require( "./assets/img/emergency/ambulance.jpg"),
women : require( "./assets/img/emergency/women.jpg"),
child : require( "./assets/img/emergency/child.jpg"),
imgp: require("./assets/img/imgp.jpg"),
imgrajs: require("./assets/img/monuments/rajasthan_top_20_historical_sites.jpg"),
india: require("./assets/img/india.jpg"),

golden: require("./assets/img/travel/golden.jpg"),
unity: require("./assets/img/travel/unity.jpg"),
ram: require("./assets/img/travel/ram.jpg"),
hawa: require("./assets/img/travel/hawa.jpg"),
}
export default Images

